module.exports = __webpack_public_path__ + "img/l8.8a845daf.png";